import { Component, OnInit } from '@angular/core';
import { StatsService } from '../../../../resources/stats/stats.service';
import { DailySales } from '../../../../model/stat/daily-sales';

@Component({
  selector:    'app-sales',
  templateUrl: './sales.component.html',
  styleUrls:   [ './sales.component.scss' ]
})
export class SalesComponent implements OnInit {

  sales: DailySales;

  chartData: any[];

  chartType = 'bar';

  colors = [ {
    backgroundColor: [ '#A6CE47',
                       '#F1F1F1' ]
  } ];

  labels = [ 'dzisiaj',
             'wczoraj' ];

  chartOptions = {
    legend:              {
      display: false
    },
    tooltips:            {
      callbacks: {
        label: function (item, data) {
          const val = data.datasets[ item.datasetIndex ].data[ item.index ];
          return Math.floor(val * 100) / 100;
        }
      }
    },
    scales: {
      yAxes: [{
        display: false
      }]
    },
    responsive:          true,
    maintainAspectRatio: false
  };

  constructor(private stats: StatsService) {
  }

  ngOnInit() {
    this.stats.dailySales()
      .subscribe((data) => {
        this.chartData = [
          {
            data: [ data.amount, data.yest_amount ]
          }
        ];
        this.sales = data;
      });
  }

}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/stats/sales/sales.component.ts